import {
  IN_TRANSIT_TRANSFER_ORDER_STATUSES,
  TRANSFER_ORDER_OPEN_STATUS_IDS,
  TRANSFER_ORDER_UNSHIPPED_OPEN_STATUS_IDS,
  TransferOrderStatus,
} from '@nudool/shared';

export type TransferOrderWorkspaceQueue =
  'late' | 'drafts' | 'partiallyReceived' | 'arrivingThisWeek' | 'inTransit' | 'open' | 'all';

export type TransferOrderWorkspaceQueueDefinition = {
  id: TransferOrderWorkspaceQueue;
  label: string;
  statusIds: readonly number[] | null;
  inTransitMinDays?: number;
  emptyTitle: string;
  emptyDescription: string;
};

export const TRANSFER_ORDER_WORKSPACE_QUEUES: ReadonlyArray<TransferOrderWorkspaceQueueDefinition> =
  [
    {
      id: 'late',
      label: 'Late ship',
      statusIds: TRANSFER_ORDER_UNSHIPPED_OPEN_STATUS_IDS,
      emptyTitle: 'No late shipments',
      emptyDescription: 'Every transfer still to ship is within its est. ship date.',
    },
    {
      id: 'drafts',
      label: 'Unissued drafts',
      statusIds: [TransferOrderStatus.DRAFT],
      emptyTitle: 'No unissued drafts',
      emptyDescription: 'Every draft transfer has been issued or cleared.',
    },
    {
      id: 'partiallyReceived',
      label: 'Partially received',
      statusIds: [TransferOrderStatus.PARTIALLY_RECEIVED],
      emptyTitle: 'Nothing partially received',
      emptyDescription: 'No transfer is waiting on the rest of its shipment.',
    },
    {
      id: 'arrivingThisWeek',
      label: 'Shipping this week',
      statusIds: TRANSFER_ORDER_OPEN_STATUS_IDS,
      emptyTitle: 'Nothing scheduled this week',
      emptyDescription: 'No open transfer has an est. ship date in the next seven days.',
    },
    {
      id: 'inTransit',
      label: 'In transit',
      statusIds: IN_TRANSIT_TRANSFER_ORDER_STATUSES,
      inTransitMinDays: 0,
      emptyTitle: 'Nothing in transit',
      emptyDescription: 'Every shipped unit has been received.',
    },
    {
      id: 'open',
      label: 'All open',
      statusIds: TRANSFER_ORDER_OPEN_STATUS_IDS,
      emptyTitle: 'No open transfers',
      emptyDescription: 'Nothing is currently issued, picking, shipped, or partially received.',
    },
    {
      id: 'all',
      label: 'Everything',
      statusIds: null,
      emptyTitle: 'No transfer orders yet',
      emptyDescription: 'Create a transfer to move inventory from one warehouse to another.',
    },
  ];
